import React, { ReactElement } from 'react';

import FadeIn from 'components/animations/fade-in';
import './alert.scss';

interface AlertProps {
  message: string;
  variant?: string;
}

export default function Alert({
  message,
  variant = 'danger',
}: AlertProps): ReactElement {
  return message ? (
    <FadeIn direction='left'>
      <div className={`alert-wrapper ${variant}`}>
        <p className='white'>{message}</p>
      </div>
    </FadeIn>
  ) : (
    <></>
  );
}
